// extracted by mini-css-extract-plugin
export var brand = "_b4-9";
export var compact = "_b4-6";
export var extraSmall = "_b4-7";
export var icon = "_b4-0";
export var large = "_b4-4";
export var light = "_b4-1";
export var medium = "_b4-5";
export var outline = "_b4-b";
export var primaryDark = "_b4-a";
export var primaryLight = "_b4-8";
export var primaryModern = "_b4-c";
export var success = "_b4-2";
export var successSolid = "_b4-3";